import React from "react";
import TextInput from "../../../common/forms/input/TextInput";
import PropTypes from "prop-types";
import { FormGroup } from "reactstrap";
import FormItem from "../../../common/forms/FormItem";
import { Field } from "redux-form";
import { isRequired } from "../../../../utils/validators";

export const BusChassisFormFields = ({
    showEndointLabel,
    initialValues
}) => {

    return (
        <>
            <FormGroup row>
                <FormItem label="Marca" required={[[isRequired]]}>
                    <Field
                        name="make"
                        component={TextInput}
                        type="text"
                        placeholder="Marca"
                    />
                </FormItem>
            </FormGroup>
            <FormGroup row>
                <FormItem label="Modelo" required={[[isRequired]]}>
                    <Field
                        name="model"
                        component={TextInput}
                        type="text"
                        placeholder="Modelo"
                    />
                </FormItem>
            </FormGroup>
            <FormGroup row>
                <FormItem label="Año" required={[[isRequired]]}>
                    <Field
                        name="year"
                        component={TextInput}
                        type="number"
                        placeholder="Año"
                    />
                </FormItem>
            </FormGroup>
            <FormGroup row>
                <FormItem label="Capacidad de Combustible (gal)" required={[[isRequired]]}>
                    <Field
                        name="fuelCapacity"
                        component={TextInput}
                        type="number"
                        placeholder="Capacidad de Combustible (gal)"
                    />
                </FormItem>
            </FormGroup>
        </>
    );
}

BusChassisFormFields.propTypes = {
    showBusChassisLabel: PropTypes.bool,
    initialValues: PropTypes.shape({
    }),
};

BusChassisFormFields.defaultProps = {
    showBusChassisLabel: true,
    initialValues: null,
};

export default BusChassisFormFields;